<template>
  <div>
    <head>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,700"
        rel="stylesheet"
      />
      <!-- Bulma Version 0.7.1-->
    </head>

    <body>
      <section class="hero is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column is-4 is-offset-4">
              <h3 class="title has-text-grey" v-if="appName === 'ANSI'">
                ANSI CRM
              </h3>
              <h3 class="title has-text-grey" v-else>
                ADAPTIVE NETS
              </h3>
              <p class="subtitle has-text-grey">Please login to proceed.</p>
              <div class="box">
                <figure class="avatar">
                  <img
                    src="../../assets/ansi-logo-without-name.png"
                    width="128"
                    height="128"
                    v-if="appName === 'ANSI'"
                  />
                  <img
                    src="../../assets/adaptive-logo-without-name.png"
                    width="128"
                    height="128"
                    v-else
                  />
                </figure>
                <br />
                <div class="field">
                  <div class="control">
                    <input
                      class="input is-large"
                      v-validate="'required'"
                      type="text"
                      name="username"
                      placeholder="Your username"
                      v-model="login.username"
                      @keyup.enter="triggerLogin"
                    />
                    <span class="has-text-danger">{{
                      errors.first("username")
                    }}</span>
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      class="input is-large"
                      v-validate="'required'"
                      type="password"
                      name="password"
                      placeholder="Your Password"
                      v-model="login.password"
                      @keyup.enter="triggerLogin"
                    />
                    <span class="has-text-danger"
                      >{{ errors.first("password") }}
                    </span>
                  </div>
                </div>
                <button
                  id="loginButton"
                  :class="loginButton"
                  @click="loginUser"
                  :disabled="!isValidationPassed"
                  ref="loginRef"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </body>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VeeValidate from "vee-validate";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";

const appToast = new AppToast();
const appButton = new AppButton();

Vue.use(VeeValidate);

export default {
  data() {
    return {
      appName: process.env.VUE_APP_ANOTHER_VARIABLE,
      login: {},
      loginButton: this.isLoggingIn(false)
    };
  },
  computed: {
    isValidationPassed() {
      return this.login.username && this.login.password;
    }
  },
  methods: {
    triggerLogin() {
      this.$refs.loginRef.click();
    },
    loginUser() {
      this.loginButton = this.isLoggingIn(true);
      axios
        .post(`api/auth/login`, this.login)
        .then(response => {
          if (response.data) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("refreshToken", response.data.refreshToken);
            window.location.href = "/";
          }
        })
        .catch(error => {
          appToast.danger(error.response.data);
        })
        .then(() => {
          this.loginButton = this.isLoggingIn(false);
        });
    },
    isLoggingIn(val) {
      if (val) {
        return "button is-block is-info is-large is-fullwidth is-loading";
      } else {
        return "button is-block is-info is-large is-fullwidth";
      }
    }
  }
};
</script>
